import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['status']
  static values = { autosaveMethod: String, autosaveUrl: String }

  connect () {
    if (this.hasAutosaveUrlValue && this.autosaveUrlValue !== '') this.setStatus('draft')
  }

  disconnect () {
    clearTimeout(this.autosaveTimeout)
  }

  csrfToken () {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }

  queueAutosave () {
    if (!this.hasAutosaveUrlValue || this.autosaveUrlValue === '') return

    this.setStatus('draft')
    clearTimeout(this.autosaveTimeout)
    this.autosaveTimeout = setTimeout(() => this.save(), 1000)
  }

  async save () {
    this.setStatus('saving')

    const body = new FormData(this.element)
    body.append('autosave', '1')

    try {
      const response = await fetch(this.autosaveUrlValue, {
        method: this.autosaveMethodValue || 'PATCH',
        headers: {
          Accept: 'application/json, text/plain',
          'X-CSRF-Token': this.csrfToken()
        },
        body
      })

      if (response.ok && (this.autosaveMethodValue || 'PATCH') === 'POST') {
        const data = await response.json()
        this.autosaveMethodValue = 'PATCH'
        this.autosaveUrlValue = data.autosave_url
        this.element.action = data.autosave_url
        this.element.method = 'post'
        this.addPatchMethodOverride()
      }

      this.setStatus(response.ok ? 'saved' : 'save failed')
    } catch (_error) {
      this.setStatus('save failed')
    }
  }

  setStatus (status) {
    if (!this.hasStatusTarget) return

    this.statusTarget.textContent = status
  }

  addPatchMethodOverride () {
    let methodInput = this.element.querySelector('input[name="_method"]')
    if (!methodInput) {
      methodInput = document.createElement('input')
      methodInput.type = 'hidden'
      methodInput.name = '_method'
      this.element.appendChild(methodInput)
    }
    methodInput.value = 'patch'
  }
}
